import { SelectableItem } from "../components/action-modals/item-selection/item-row";
import { VisibilityType } from "../components/posts/visibility-modal/post-visibility-modal";

export type PostAuthor = {
  id: string;
  display_name: string | null;
};

export type PostFilePayload = {
  attachment_id?: string;
  uri: string;
  fileName: string;
  type?: string;
  file?: File;
  file_size: number;
};

export const REACTIONS = [
  { id: "like", label: "Like", emoji: "👍", color: "#1877F2" },
  { id: "heart", label: "Heart", emoji: "❤️", color: "#F33E58" },
  { id: "laugh", label: "Laugh", emoji: "😂", color: "#F7B125" },
  { id: "sad", label: "Sad", emoji: "😢", color: "#F7B125" },
  { id: "mad", label: "Mad", emoji: "😡", color: "#E9710F" },
  { id: "surprise", label: "Surprise", emoji: "😮", color: "#F7B125" },
];

export type ReactionType = (typeof REACTIONS)[number]["id"] | null;
export type ReactionCounts = Record<Exclude<ReactionType, null>, number>;

export type ReactToPostPayload = {
  postId: string;
  userId: string;
  newReaction: ReactionType;
  previousReaction: ReactionType;
  currentCounts: ReactionCounts;
  existingReactionId?: string;
  reactorName?: string;
};

export type PostFile = {
  attachment_id?: string;
  url: string;
  mime_type?: string;
  file_name: string | undefined;
  file_size: number | null;
};

export type PostTag = {
  id: string;
  name: string;
};

export type Post = {
  ItemId: string;
  content: string;
  authorSnapshot: {
    firstName: string;
    lastName: string;
    profileImageUrl?: string;
    userId: string;
  };
  mentionedUsers?: SelectableItem[];
  hashtags?: string[];
  commentCount: number;
  reactionCount: ReactionCounts;
  userReaction?: ReactionType;
  visibility: VisibilityType;
  visibleToGroupIds?: string[];
  visibleToUserIds?: string[];
  attachmentUrls?: string[];
  CreatedDate: string;
  CreatedBy: string;
  saveCount: number;
};

export type CommentAuthorSnapshot = {
  firstName?: string;
  lastName?: string;
  profileImageUrl?: string;
};
export type PostComment = {
  ItemId: string;
  postId: string;
  parentCommentId?: string | null;

  content: string;
  replyCount: number;

  authorId: string;
  authorSnapshot: CommentAuthorSnapshot;
  reactionCount: Partial<Record<Exclude<ReactionType, null>, number>>;

  CreatedDate: string;
  CreatedBy?: string;
};

export type PostCommentsResponse = PostComment[];

export type CreateCommentPayload = {
  postId: string;
  parentCommentId?: string;
  parentReplyCount?: number;
  postCommentCount?: number;
  authorId: string;
  content: string;
  authorSnapshot: {
    firstName?: string;
    lastName?: string;
    email?: string;
    profileImageUrl?: string;
  };
  replyCount: number;
};

export type CreateReplyPayload = {
  commentId: string;
  body: string;
};

export type CreatePostPayload = {
  content: string;
  hashtags?: string[];
  mentionedUsers?: SelectableItem[];
  visibility?: VisibilityType;
  groupId?: string;
  visibleToGroupIds?: string[];
  visibleToUserIds?: string[];
  score: number;
  authorSnapshot: {
    firstName: string;
    lastName: string;
    email: string;
    profileImageUrl?: string;
  };
  attachmentUrls?: string[];
};

export type UpdatePostPayload = {
  id: string;
  content: string;
  hashtags?: string[];
  mentionedUsers?: SelectableItem[];
  visibility?: VisibilityType;
  visibleToGroupIds?: string[];
  visibleToUserIds?: string[];
  attachmentUrls?: string[];
};

export type UpdatePostScorePayload = {
  id: string;
  score: number;
};

export type ReactToCommentPayload = {
  commentId: string;
  postId: string;
  userId: string;
  newReaction: ReactionType | null;
  previousReaction: ReactionType | null;
  currentCounts: Partial<Record<Exclude<ReactionType, null>, number>>;
  existingReactionId?: string | null;
};

export type GetPostsResponse = {
  posts: Post[];
  meta: {
    page: number;
    last: number;
    next?: number;
    next_url?: string;
    count: number;
    limit: number;
  };
};

export type GetTagsResponse = {
  tags: string[];
};

export type UserPhoto = {
  id: string;
  file_name: string;
  file_size: number | null;
  mime_type: string;
  url: string;
};

export type GetUserPhotosResponse = {
  data: UserPhoto[];
  meta: {
    page: number;
    last: number;
    count: number;
  };
};

export type GetUserDocumentsResponse = {
  data: UserPhoto[];
  meta: {
    page: number;
    last: number;
    count: number;
  };
};
